import React from 'react';
import styled from '@emotion/styled';
import type { MinWidthProps } from 'styled-system';
import { minWidth, themeGet } from 'styled-system';

import { Flex } from 'common/components/Flex';
import Icon from 'common/components/Icon';
import { linkStyles } from 'common/components/Link';
import { BodyRegularBR2 } from 'common/components/Typography';
import { useLocalization } from 'common/providers/LocaleProvider';

const INFO_ICON_SIZE = [24, null, null, 28];

const InfoIcon = styled(Icon)<MinWidthProps>`
  ${minWidth};
`;

const Text = styled(BodyRegularBR2)`
  a {
    ${linkStyles};
    color: ${themeGet('colors.sys.neutral.text.strong')};
  }
`;

const ReferralNotAllowedMessage = ({ id }: { id?: string }) => {
  const { t, r, prefix } = useLocalization();

  return (
    <Flex mt="sp_16" alignItems="center">
      <InfoIcon name="info" size={INFO_ICON_SIZE} minWidth={INFO_ICON_SIZE} />
      <Text
        id={id}
        ml="sp_8"
        dangerouslySetInnerHTML={{
          __html: r.t('h24_refer_not_available', {
            homepage_href: prefix(t('h24_home_url')),
          }),
        }}
      />
    </Flex>
  );
};

export default ReferralNotAllowedMessage;
